// * Import required libraies
import React, { useContext } from "react";

// * Import 3rd party lib comp
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core";
import { Box } from "@material-ui/core";

// * Import custom components
import SigviewTypography from "../../components/Common/SigviewTypography";
import { ThemeContext } from "../../contexts/ThemeContext";

function LayoutMetricChartsMenu(props = {}) {
  // * Destructure props
  const { children = <></>, showTitle = false, variant = "workspace" } = props;

  // * Define requires static variables
  // * Define required hooks
  const { state: themeState } = useContext(ThemeContext);
  const themeColors = themeState.themes[themeState.activeTheme];

  const useStyles = makeStyles((theme) => ({
    root: {
      // padding: "0px 22px 10px 22px",
    },
    leftPanel: { display: "flex", alignItems: "center" },
    rightPanel: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      alignItems: "center",
    },
    itemContainer: {
      display: "flex",
      flexDirection: "row",
      height: "25px",
      // alignItems: "center",
      // justifyContent: "flex-end",
    },
    itemTitle: {},
    item: {
      display: "flex",
      alignItems: "center",
      backgroundColor: themeColors["timeFiltersBgColor"],
      marginLeft: "5px",
      padding: "0px 0px",
      boxShadow: theme.palette.misc["dsItemBoxShadow"],
      borderRadius: "5px",
      // width: "100%",
      justifyContent: "center",
      width: "max-content",
    },
    item2: {
      display: "flex",
      alignItems: "center",
      backgroundColor: themeColors["timeFiltersBgColor"],
      marginLeft: "15px",
      padding: "0px 0px",
      boxShadow: theme.palette.misc["dsItemBoxShadow"],
      borderRadius: "5px",
      // width: "100%",
      justifyContent: "center",
      width: "max-content",
    },
    item3: {
      display: "flex",
      alignItems: "center",
      padding: "0px 0px",
      justifyContent: "center",
      // marginLeft: "15px"
    },
    msvRightPanel: {
      display: "flex",
      alignItems: "center",
      marginLeft: "5px",
      padding: "0px 0px 0px 3px",
      boxShadow: theme.palette.misc["dsItemBoxShadow"],
      borderRadius: "2px",
    },
    lastChildInRightPanel: { marginLeft: "15px" },
  }));
  const classes = useStyles();
  const {
    root,
    leftPanel,
    rightPanel,
    itemContainer,
    itemTitle,
    item,
    item2,
    item3,
    msvRightPanel,
  } = classes;
  var itemInRightPanel = item;
  if (variant === "msv") itemInRightPanel = msvRightPanel;

  return (
    <Grid container className={root}>
      <Grid item xs={4} className={leftPanel}>
        <Box className={itemContainer}>
          {showTitle && (
            <Box className={itemTitle}>
              <SigviewTypography
                style={{
                  height: "max-content",
                  margin: "0px 0px 5px 3px !important",
                }}
                variant="pSmaller"
              >
                Global Sort
              </SigviewTypography>
            </Box>
          )}

          <Box className={item}>{children[0]}</Box>
        </Box>
        <Box className={item2}>{children[1]}</Box>
        <Box className={item3}>{children[2]}</Box>
      </Grid>
      <Grid item xs={8} className={rightPanel}>
        <Box className={itemContainer}>
          {showTitle && (
            <Box className={itemTitle}>
              <SigviewTypography
                style={{
                  height: "max-content",
                  margin: "0px 0px 5px 3px !important",
                }}
                variant="pSmaller"
              >
                Row Count
              </SigviewTypography>
            </Box>
          )}

          {/* <Box className={item}>{children[1]}</Box> */}
        </Box>
        <Box
          className={`${classes.itemContainer} ${classes.lastChildInRightPanel}`}
        >
          {showTitle && (
            <Box className={itemTitle}>
              <SigviewTypography
                style={{
                  height: "max-content",
                  margin: "0px 0px 5px 3px !important",
                }}
                variant="pSmaller"
              >
                Grid View
              </SigviewTypography>
            </Box>
          )}

          <Box className={itemInRightPanel}>{children[3]}</Box>
        </Box>
      </Grid>
    </Grid>
  );
}

export default LayoutMetricChartsMenu;
